import {
  useParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

function useSearchParam(name: string, defaultValue: string) {
  const [searchParams] = useSearchParams();
  const currentParam = searchParams.get(name);
  const [value, setValue] = useState<string>(currentParam ?? defaultValue);

  useEffect(() => {
    const currentParam = searchParams.get(name);
    setValue(currentParam ?? defaultValue);
  }, [searchParams, defaultValue]);

  const updateValue = useCallback(
    (value: string) => {
      setValue(value);
    },
    [setValue],
  );

  return [value, updateValue];
}

export { useParams, useLocation, useNavigate, useSearchParams, useSearchParam };
